import { render, staticRenderFns } from "./DialogSetLaborBurden.vue?vue&type=template&id=7cb42fb2"
import script from "./DialogSetLaborBurden.vue?vue&type=script&lang=js"
export * from "./DialogSetLaborBurden.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports